import fetch from "./fetch";
/**
 * 文档管理器
 */
const documentApi = {
  // 分页
  documentPageRequst(data) {
    return fetch({
      isLoading: true,
      url: "/document/page",
      method: "GET",
      params: data,
    });
  },

  // 新增修改
  documentSaveAndUpdateRequst(data) {
    return fetch({
      isLoading: true,
      url: "/document/saveAndUpdate",
      method: "POST",
      data,
    });
  },
};

export default documentApi;
